import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { AlertTriangle } from 'lucide-react';
import { axios, auth, mbUrl, muted, runCall } from './mbApi';

const WORD = 'MATIKAN';

export const DangerZone = ({ ibId, isAdmin, onChanged }) => {
  const [open, setOpen] = useState(false);
  const [typed, setTyped] = useState('');
  const [busy, setBusy] = useState(false);
  const go = () => runCall(setBusy, async () => {
    await axios.put(mbUrl(ibId, '/settings'), { enabled: false }, auth());
    setOpen(false);
    onChanged();
  }, 'Marketing Hub dimatikan untuk channel ni');
  return (
    <div className="rounded-xl border border-red-500/40 p-4 space-y-2" data-testid="mb-danger-zone">
      <p className="text-sm font-semibold text-red-400 flex items-center gap-2"><AlertTriangle size={16} /> Tindakan berisiko</p>
      <p className={`text-sm ${muted}`}>
        Matikan modul akan menyembunyikan Marketing Hub untuk semua orang dalam channel ni. Brief, ujian, link iklan dan sejarah KEKAL dan boleh dihidupkan semula.
      </p>
      {isAdmin ? (
        <Button variant="outline" className="h-10 border-red-500/50 text-red-400" onClick={() => { setTyped(''); setOpen(true); }} data-testid="mb-disable-module-btn">
          Matikan modul…
        </Button>
      ) : <p className={`text-xs ${muted}`} data-testid="mb-disable-admin-only">Hanya admin boleh hidupkan / matikan modul.</p>}
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent className="mb-scope" data-testid="mb-disable-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Matikan Marketing Hub untuk channel ni?</AlertDialogTitle>
            <AlertDialogDescription>
              Yang berubah: tab Marketing Hub tak boleh digunakan (semua butang & sync berhenti). Yang KEKAL: semua data, link iklan & redirect Telegram.
              Taip <span className="font-mono font-semibold">{WORD}</span> untuk sahkan.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <Input value={typed} onChange={(e) => setTyped(e.target.value)} aria-label="Taip MATIKAN untuk sahkan" className="h-10" data-testid="mb-disable-typed" />
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="mb-disable-cancel">Batal</AlertDialogCancel>
            <AlertDialogAction disabled={typed.trim() !== WORD || busy} onClick={(e) => { e.preventDefault(); go(); }}
              className="bg-red-600 hover:bg-red-700" data-testid="mb-disable-confirm">Matikan</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};
